/**
 * Created by wtd on 2018/1/16.
 */

import React, {Component} from 'react';
import { message,Button,Modal } from 'antd';
import './style.scss'

class ReportFormDetail extends Component {
    constructor(props){
        super(props)
    }

    render(){
        const {report} = this.props
        let agentName = report&&report.agentId?`${report.agentId.lastName}${report.agentId.firstName}`:''
        let lossAssOptionsDiv = []
        if( report&&report.amountMoney&&report.handleOpinions){
            lossAssOptionsDiv.push(
                <p>
                    <span> {`金额：${report.amountMoney}元`}</span>
                    <span>{`处理意见：${report.handleOpinions}`}</span>
                </p>
            )
        }
        if( report&&report.lossAssOptionData&&report.lossAssOptionData.length>0){
            report.lossAssOptionData.map(loss=>{
                lossAssOptionsDiv.push(
                    <p className="report-title-detail">
                        <span>{`金额：${loss.amountMoney}元`}</span>
                        <span>{`处理意见：${loss.handleOpinions}`}</span>
                    </p>
                )
            })
        }
        return(
            <div className="formDetailBox">
                <div className="formHeadList">
                    <p>
                        <span>工单信息:&nbsp;{`受理坐席:${agentName}`}</span>
                    </p>
                    <p>
                        <span>{'工单流水号：'+(report?report.flowId:'')}</span>
                    </p>
                    {lossAssOptionsDiv}
                </div>
                <div className="formList">
                    {/*<span style={{marginBottom:"8px"}}>{`备注：${report ? report.summaryDescr : ''}`}</span>*/}
                    <div className="formContentList">
                        <div className="formRow">
                            <label htmlFor="报案单号">报案单号：</label>
                            <input type="text" readOnly="readOnly" value={report?report.reportId:''} style={{marginRight:"11px"}}/>
                            <label htmlFor="报案单号">报案电话*：</label>
                            <input type="text" readOnly="readOnly" value={report?report.reporterCellPhone:''}/>
                        </div>
                        <div className="formRow">
                            <label htmlFor="车牌号*"><span>车牌号*：</span></label>
                            <input type="text" readOnly="readOnly" value={report?report.carNumber:''} style={{marginRight:"10px",marginLeft:"8px"}} />
                            <label htmlFor="报案地址*"><span>报案地址*：</span></label>
                            <input type="text" readOnly="readOnly" value={report?report.place:''}/>
                        </div>
                        <div className="formRow">
                            <label htmlFor="报案人">报案人：</label>
                            <input type="text" readOnly="readOnly" value={report?report.reporter:''} style={{marginRight:"11px",marginLeft:"13px"}} />
                            <label htmlFor="报案时间">报案时间：</label>
                            <input type="text" readOnly='readOnly' value={report?report.date:''} style={{marginLeft:"6px"}} />
                        </div>
                        <div className="formRow">
                            <label htmlFor="协赔员">协赔员：</label>
                            <input type="text" value={report&&report.claimAdjuster? `${report.claimAdjuster.loginName}  ${report.claimAdjuster.userName}`:''} readOnly='readOnly' style={{marginRight:"3px",marginLeft:"12"}} />
                            <label htmlFor="标的车型">标的车车型：</label>
                            <input type="text" value={report?report.carType:''}  readOnly='readOnly'/>
                        </div>
                        <div className="formRow">
                            <label htmlFor="出险经过">出险经过：</label>
                            <textarea readOnly='readOnly' value={report?report.accidentDetail:''} rows="2" cols="70" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ReportFormDetail